/* import __COLOCATED_TEMPLATE__ from './stage-text.hbs'; */
import Component from '@glimmer/component';
import { toOrdinal } from '../../utils/common';

interface StageTextCircuitAnnotationArgs {
  item: StageItemDetails;
  matrix: string;
}

type StageItemDetails = {
  stageLetter: string;
  stageOrder: number;
  stageFilterType: string;
  stageImplementation: string;
};

export default class StageTextCircuitAnnotation extends Component<StageTextCircuitAnnotationArgs> {
  get stageOrder(): string {
    return toOrdinal(this.args.item.stageOrder);
  }
}
